document.addEventListener('DOMContentLoaded', function () {
  const heading = [...document.querySelectorAll('h2.banner__heading')]
    .find(h2 => h2.textContent.trim() === 'More Than Just Keyrings');

  if (!heading) return;

  if (!document.querySelector('#hero-subheading-style')) {
    const style = document.createElement('style');
    style.id = 'hero-subheading-style';
    style.textContent = `
      .hero-subheading {
        margin-top: 30px!important;
        font-family: var(--font-heading-family);
        font-size: 36px;
        line-height: 1.2;
        font-weight: 500;
        color: #c89a5b;
      }

      @media screen and (max-width: 749px) {
        .hero-subheading {
          font-size: 24px;
          margin-top: 8px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  if (!heading.nextElementSibling?.classList.contains('hero-subheading')) {
    const subheading = document.createElement('h3');
    subheading.className = 'hero-subheading';
    subheading.textContent = 'Stories You Can Hold';

    heading.insertAdjacentElement('afterend', subheading);
  }
});